import { render, staticRenderFns } from "./Etiqueta.vue?vue&type=template&id=f9e92d6e&"
import script from "./Etiqueta.vue?vue&type=script&lang=js&"
export * from "./Etiqueta.vue?vue&type=script&lang=js&"
import style0 from "./Etiqueta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports